// src/composables/useGlobalTimer.js
import { ref, computed } from 'vue';

const timerActive = ref(false);
const timerCountdown = ref(0);
let timerInterval = null;

const STORAGE_KEY = 'global-timer-expiry';

function updateFromStorage() {
  const expiry = parseInt(localStorage.getItem(STORAGE_KEY), 10);
  if (!isNaN(expiry)) {
    const now = Date.now();
    const remaining = Math.floor((expiry - now) / 1000);
    if (remaining > 0) {
      startTimer(remaining, true);
    } else {
      resetTimer();
    }
  }
}

function startTimer(seconds, fromStorage = false) {
  if (timerInterval) clearInterval(timerInterval);
  timerCountdown.value = seconds;
  timerActive.value = true;
  if (!fromStorage) {
    const expiry = Date.now() + seconds * 1000;
    localStorage.setItem(STORAGE_KEY, expiry.toString());
  }
  timerInterval = setInterval(() => {
    timerCountdown.value--;
    if (timerCountdown.value <= 0) {
      timerActive.value = false;
      clearInterval(timerInterval);
      timerInterval = null;
      localStorage.removeItem(STORAGE_KEY);
    }
  }, 1000);
}

function resetTimer() {
  timerActive.value = false;
  timerCountdown.value = 0;
  if (timerInterval) {
    clearInterval(timerInterval);
    timerInterval = null;
  }
  localStorage.removeItem(STORAGE_KEY);
}

// Inicializar desde localStorage al cargar el composable
updateFromStorage();

export function useGlobalTimer() {
  return {
    timerActive: computed(() => timerActive.value),
    timerCountdown: computed(() => timerCountdown.value),
    startTimer,
    resetTimer,
  };
}